import React, { forwardRef, useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import Api from '../../api';
import AppSearch from '../AppSearch';
import ChannelPageCardMobile from '../ChannelPageCardMobile';
// import ChannelPageCardMobile from '../ChannelPageCardMobile';
import Loader from '../Loader';
import styles from './styles.module.css';

const SearchPart = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  // const [searchValue, setSearchValue] = useState('');
  const [count, setCount] = useState(0);
  const {
    setShowSearch,
    setShowFiles,
    setUserChannelId,
    setActiveUser,
    setActiveMessage,
    setActiveAudio,
    showSearch,
    searchValue,
    setSearchValue,
  } = useContext(AdminContext);

  useEffect(() => {
    setLoading(false);
    const params = {
      params: {
        searchName: searchValue,
        start: 0,
        limit: 20,
      },
    };
    if (searchValue?.trim()?.length != 0) {
      searchFunction(params, 1);
    } else {
      setData([]);
      setLoading(false);
      setCount(0);
    }
  }, [searchValue]);

  const getMorePosts = () => {
    let params = {
      params: {
        searchName: searchValue,
        start: data?.length,
        limit: 10,
      },
    };
    searchFunction(params, 2);
  };

  const searchFunction = (params, type) => {
    if (type == 1) {
      setLoading(true);
    }
    Api.userList(params)
      .then((res) => {
        if (type == 1) {
          setData([...res.data.response]);
        }
        if (type == 2) {
          const newarray = [...data.concat(res.data.response)];
          setData(newarray);
        }
        setCount(res?.data?.response_details?.count);
        setLoading(false);
      })
      .catch((err) => {
        // setData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (data.length < count) {
      setHasMore(true);
    } else {
      setHasMore(false);
    }
  }, [data, count]);
  console.log('data==', data);
  return (
    <div
      className={`flex flex-col justify-start items-start w-full h-full chat__users  ${styles.container}`}
    >
      {/* <div
        className={`flex flex-row justify-center items-center w-full h-auto`}
      >
        {showSearch && (
          <AppIcons.closeIcon
            onClick={() => {
              setShowSearch(false);
              setShowFiles(false);
              setUserChannelId('');
              setActiveUser();
              setActiveMessage('');
              setActiveAudio();
            }}
            className={`${
              // direction == 'rtl' ? 'mr-auto' : 'ml-auto'
              'mr-auto'
            } flex flex-row justify-center items-center cursor-pointer`}
            fill={`#999`}
            width={'12px'}
            height={'12px'}
          />
        )}
        <AppSearch
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          autoFocus={true}
        />
      </div> */}
      <div
        id="scrollableDiv"
        className={`infiniteContent flex flex-col justify-start items-start w-full box-border  ${styles.infiniteContainer}`}
        style={{
          //   minHeight: '80%',
          height: 'auto',
          //   overflowY: 'auto',
          margin: '10px 0',
        }}
      >
        {!loading ? (
          <InfiniteScroll
            dataLength={data?.length}
            next={() => getMorePosts()}
            hasMore={hasMore}
            scrollThreshold={'100px'}
            loader={<Loader width={'w-full'} height={styles.loaderHeight} />}
            scrollableTarget="scrollableDiv"
          >
            <div
              className={`flex flex-col flex-wrap justify-start items-start w-full h-auto`}
            >
              {data?.map((item, index) => (
                <ChannelPageCardMobile
                  key={item.id}
                  avatar={item?.image?.name}
                  name={item?.channelName}
                  // description={item?.description}
                  // followNum={item?.followNum}
                  // videoNum={item?.videoNum ? item?.videoNum : 0}
                  // src={item?.fileWideImage?.name}
                  id={item?.id}
                  item={item}
                  uuid={item?.uuid}
                  ref={ref}
                  setServerError={props?.setServerError}
                  fileType={props?.fileType}
                  loadingFile={props?.loadingFile}
                  setLoadingFile={props?.setLoadingFile}
                  loadingFileButton={props?.loadingFileButton}
                  setLoadingFileButton={props?.setLoadingFileButton}
                  setLoadingOldMessages={props?.setLoadingOldMessages}
                  setTypingStatus={props?.setTypingStatus}
                  users={props?.users}
                  chatTypePrivate={props?.chatTypePrivate}
                  replyValue={props?.replyValue}
                  setReplyValue={props?.setReplyValue}
                  setMessages={props?.setMessages}
                  content={props?.content}
                  handleSendMessage={props?.handleSendMessage}
                  sendFunction={props?.sendFunction}
                  notTyping={props?.notTyping}
                  message={props?.message}
                  setMessage={props?.setMessage}
                  handleDrag={props?.handleDrag}
                  handleDrop={props?.handleDrop}
                  sendContact={props?.sendContact}
                />
              ))}
            </div>
          </InfiniteScroll>
        ) : (
          <Loader width={`w-full  ${styles.loader}`} />
        )}
      </div>
    </div>
  );
});
export default SearchPart;
